<template>
  <div v-if="loading" class="content-loader">
    <Spinner />
  </div>
  <FormControl
      type="select"
      v-model="userLang"
      payload="/payload/language/language"
      inline
      grid
      label-disabled
      load-once
      @select="onChangeLocale"
  >
    <template #option="{option}">
      <div class="language">
        <div class="flag">
          <img :src="option.src" :alt="option.title">
        </div>

        <span class="text-truncate fw-medium">
          {{ option.title }}
        </span>
      </div>
    </template>
  </FormControl>
</template>
<script setup>
import {useI18n} from "vue-i18n";
import {ref} from "vue";
import axios from "axios";
import {useStore} from "vuex";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import Spinner from "@/js/Elements/Spinner.vue";
import {useEmitter} from "@/js/Plugins/Emitter.js";
import {useLocale} from "@/js/Plugins/Locale.js";

const t = useI18n();
const loading = ref(false);
const store = useStore();
const userLang = ref(store.getters['auth/user'].lang);
const emitter = useEmitter();
const locale = useLocale();


function onChangeLocale(option) {
  if (!option) return;

  loading.value = true;
  axios.get('/payload/language/locale', { params: { lang: option.id }})
      .then((response) => {
        const data = response.data.data;
        locale.set(data, true);
        store.commit('builder/clear');
        emitter.emit('builder:reload');
        updateSidebarLink(data.title, data.flag);
      })
      .finally(() => loading.value = false);
}


function updateSidebarLink(title, flag) {
  const link = store.getters['sidebar/flatList'].find(link =>  link.name === 'language');
  if (!link) return;
  link.title = title;
  link.image = flag;
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.language {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: spacing(2);


  .flag {
    height: toRem(24);
    border-radius: toRem(5);
    border: themeColor('border') solid toRem(1);
    overflow: hidden;
    padding: toRem(3);

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>